import ContactPage from "pages/ContactPage";
import React from "react";

const ContactRoute = () => <ContactPage />;

export default ContactRoute;
